import React from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import styles from './Quiz.module.sass';
import Introduction from '../introduction/Introduction';
import Category from '../category/Category';
import Banner from '../banner/Banner';
import CATEGORIES from '../../constants/categories';
import GetToKnow from '../get_to_know/GetToKnow';
import Color from '../color/Color';
import Step from '../step/Step';
import SkincareMainConcern from '../skincare/skincare_main_concern/SkincareMainConcern';
import WhySpecial from '../why_special/WhySpecial';
import Texture from '../texture/Texture';
import { userObjectSelector } from '../../../user/selectors/user';
import { modalsActions } from '../../../modals/actions';
import MODALS from '../../../modals/constants/modals';
import { quizFromBackendToFrontend, quizFromFrontendToBackend } from '../../services/quiz_mapping';
import api from '../../api';
import COUNTRIES from '../../constants/countries';
import SKIN_TYPES from '../../constants/skin_types';
import MakeupArea from '../makeup/makeup_area/MakeupArea';
import MakeupType from '../makeup/makeup_type/MakeupType';
import BodyArea from '../body/body_area/BodyArea';
import BodyType from '../body/body_type/BodyType';
import BodyTexture from '../body/body_texture/BodyTexture';
import bannerImage from '../../../../images/pages/quiz/banner.jpg';
import makeupBannerImage from '../../../../images/pages/quiz/makeup_banner.jpg';
import bodyBannerImage from '../../../../images/pages/quiz/body_banner.jpg';
import hairBannerImage from '../../../../images/pages/quiz/hair_banner.jpg';
import HairArea from '../hair/hair_area/HairArea';
import HairType from '../hair/hair_type/HairType';
import HairTexture from '../hair/hair_texture/HairTexture';
import StepsFooter from '../steps_footer/StepsFooter';

const defaultQuiz = {
  id: null,
  userId: null,
  step: 0,
  color: null,
  category: null,
  concerns: [],
  uniqueIngredient: '',
  whatMakesItSpecial: '',
  texture: null,
  firstName: '',
  lastName: '',
  country: COUNTRIES.USA,
  state: '',
  age: null,
  instagramLink: '',
  facebookLink: '',
  anythingElse: '',
  howHearAboutUs: '',
  inspiration: '',
  solvingProblems: '',
  skinType: SKIN_TYPES[0],
  productType: '',
  application: '',
  lookAndFeel: '',
  shades: '',
  videoUrl: '',
  files: [],
};

const updateQuizOnServer = (quiz) => {
  api.updateQuiz(quizFromFrontendToBackend(quiz));
};

class Quiz extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      quiz: props.quiz ? quizFromBackendToFrontend(props.quiz) : defaultQuiz,
      loading: false,
    };
  }

  componentDidMount() {
    Cookies.set('signed_up_from', 'quiz');

    document.addEventListener('userLoggedIn', () => {
      api.getQuiz().then((response) => {
        const newQuiz = quizFromBackendToFrontend(response.data.quiz);

        if (newQuiz.step === 0) {
          newQuiz.step = 1;
        }

        this.setState({ quiz: newQuiz });
      });
    });

    const { quiz } = this.state;

    window.history.replaceState({ step: 0 }, '');
    for (let i = 1; i <= quiz.step; i += 1) {
      window.history.pushState({ step: i }, '');
    }

    window.onpopstate = (event) => {
      if (!event.state) { return; }

      this.goToStep(event.state.step);
    };
  }

  goToStep = (step) => {
    const { quiz } = this.state;
    const newQuiz = { ...quiz, step };
    this.setState({ quiz: newQuiz });
  };

  increaseStep = (updatedQuiz) => {
    const { user, openSignUpModal } = this.props;
    const { loading } = this.state;

    if (loading) { return; }

    if (!user) {
      openSignUpModal();

      return;
    }

    const newQuiz = { ...updatedQuiz, step: updatedQuiz.step + 1 };
    this.setState({ quiz: newQuiz });
    updateQuizOnServer(newQuiz);
    window.history.pushState({ step: newQuiz.step }, '');
  };

  decreaseStep = (updatedQuiz) => {
    const { loading } = this.state;
    if (loading) { return; }

    const newQuiz = { ...updatedQuiz, step: updatedQuiz.step - 1 };
    this.setState({ quiz: newQuiz });
    updateQuizOnServer(newQuiz);
    window.history.back();
  };

  updateQuiz = (updatedQuiz) => {
    const { loading } = this.state;
    if (loading) { return; }
    this.setState({ quiz: updatedQuiz });
  };

  finishQuiz = (updatedQuiz) => {
    const { loading } = this.state;
    const { openQuizFinishedModal } = this.props;

    if (loading) { return; }

    this.setState({ loading: true });

    api.finishQuiz(quizFromFrontendToBackend(updatedQuiz)).then(() => {
      openQuizFinishedModal(updatedQuiz.color);
    });
  };

  render() {
    const { user } = this.props;

    const { quiz, loading } = this.state;

    const customTransparentButtonStyles = () => (
      `.custom-transparent-button{\
        border: 1px solid ${quiz.color};\
      }\
      .custom-transparent-button:hover {\
        background-color: ${quiz.color}\
      }\
      .loading {\
        background-color: ${quiz.color} !important\
      }`
    );

    const getStep = () => {
      let totalSteps = 2;

      if (quiz.category === CATEGORIES.SKINCARE) {
        totalSteps = 5;
      } if (quiz.category === CATEGORIES.MAKEUP) {
        totalSteps = 5;
      } if (quiz.category === CATEGORIES.BODY) {
        totalSteps = 6;
      } if (quiz.category === CATEGORIES.HAIR) {
        totalSteps = 6;
      }

      return (
        <Step
          currentStep={quiz.step - 1}
          totalSteps={totalSteps}
          color={quiz.color}
        />
      );
    };

    const getFooter = () => {
      let steps = [];
      if (quiz.category === CATEGORIES.SKINCARE) {
        steps = ['Main Concern', 'Texture', 'Color', "Why it's special", 'About you'];
      } if (quiz.category === CATEGORIES.MAKEUP) {
        steps = ['Area', 'Type', 'Color', "Why it's special", 'About you'];
      } if (quiz.category === CATEGORIES.BODY) {
        steps = ['Area', 'Type', 'Color', "Why it's special", 'Texture', 'About you'];
      } if (quiz.category === CATEGORIES.HAIR) {
        steps = ['Type', 'Main Concern', 'Color', "Why it's special", 'Texture', 'About you'];
      }

      return (
        <StepsFooter
          steps={steps}
          currentStep={quiz.step - 1}
          goToStep={(step) => { this.goToStep(step + 1); }}
        />
      );
    };

    const getBannerImage = () => {
      if (quiz.category === CATEGORIES.BODY) {
        return bodyBannerImage;
      } if (quiz.category === CATEGORIES.MAKEUP) {
        return makeupBannerImage;
      } if (quiz.category === CATEGORIES.HAIR) {
        return hairBannerImage;
      }
      return bannerImage;
    };

    const step = getStep();

    const colorStep = (
      <Color
        key="color"
        quiz={quiz}
        increaseStep={this.increaseStep}
        decreaseStep={this.decreaseStep}
        updateQuiz={this.updateQuiz}
        step={step}
      />
    );

    const whySpecialStep = (
      <WhySpecial
        key="why special"
        quiz={quiz}
        increaseStep={this.increaseStep}
        decreaseStep={this.decreaseStep}
        step={step}
      />
    );

    const textureStep = (
      <Texture
        key="texture"
        quiz={quiz}
        increaseStep={this.increaseStep}
        decreaseStep={this.decreaseStep}
        step={step}
      />
    );

    const getToKnowStep = (
      <GetToKnow
        key="get to know"
        quiz={quiz}
        finishQuiz={this.finishQuiz}
        loading={loading}
        decreaseStep={this.decreaseStep}
        step={step}
      />
    );

    const skincareSteps = [
      <SkincareMainConcern
        key="main concern"
        quiz={quiz}
        increaseStep={this.increaseStep}
        decreaseStep={this.decreaseStep}
        step={step}
      />,
      textureStep,
      colorStep,
      whySpecialStep,
      getToKnowStep,
    ];

    const makeupSteps = [
      <MakeupArea
        key="makeup area"
        quiz={quiz}
        increaseStep={this.increaseStep}
        decreaseStep={this.decreaseStep}
        step={step}
      />,
      <MakeupType
        key="makeup type"
        quiz={quiz}
        increaseStep={this.increaseStep}
        decreaseStep={this.decreaseStep}
        step={step}
      />,
      colorStep,
      whySpecialStep,
      getToKnowStep,
    ];

    const bodySteps = [
      <BodyArea
        key="body area"
        quiz={quiz}
        increaseStep={this.increaseStep}
        decreaseStep={this.decreaseStep}
        step={step}
      />,
      <BodyType
        key="body type"
        quiz={quiz}
        increaseStep={this.increaseStep}
        decreaseStep={this.decreaseStep}
        step={step}
      />,
      colorStep,
      whySpecialStep,
      <BodyTexture
        key="body texture"
        quiz={quiz}
        increaseStep={this.increaseStep}
        decreaseStep={this.decreaseStep}
        step={step}
      />,
      getToKnowStep,
    ];

    const hairSteps = [
      <HairArea
        key="hair area"
        quiz={quiz}
        increaseStep={this.increaseStep}
        decreaseStep={this.decreaseStep}
        step={step}
      />,
      <HairType
        key="hair type"
        quiz={quiz}
        increaseStep={this.increaseStep}
        decreaseStep={this.decreaseStep}
        step={step}
      />,
      colorStep,
      whySpecialStep,
      <HairTexture
        key="hair texture"
        quiz={quiz}
        increaseStep={this.increaseStep}
        decreaseStep={this.decreaseStep}
        step={step}
      />,
      getToKnowStep,
    ];

    const otherSteps = [
      colorStep,
      getToKnowStep,
    ];

    const renderStep = (renderedStep, index) => quiz.step === index + 2 && renderedStep;

    return (
      <div className={styles.quiz}>
        <style>{customTransparentButtonStyles()}</style>
        { (quiz.step === 0 || !user) ? (
          <Introduction increaseStep={() => { this.increaseStep(quiz); }} />
        ) : (
          <>
            <Banner color={quiz.color} image={getBannerImage()} />
            { quiz.step === 1 ? (
              <Category
                quiz={quiz}
                increaseStep={this.increaseStep}
                decreaseStep={this.decreaseStep}
              />
            ) : (
              <>
                { quiz.category === CATEGORIES.SKINCARE && skincareSteps.map(renderStep)}

                { quiz.category === CATEGORIES.MAKEUP && makeupSteps.map(renderStep)}

                { quiz.category === CATEGORIES.BODY && bodySteps.map(renderStep)}

                { quiz.category === CATEGORIES.HAIR && hairSteps.map(renderStep)}

                { ![
                  CATEGORIES.SKINCARE, CATEGORIES.MAKEUP, CATEGORIES.HAIR, CATEGORIES.BODY,
                ].includes(quiz.category) && otherSteps.map(renderStep)}

                {getFooter()}
              </>
            )}
          </>
        )}
      </div>
    );
  }
}

Quiz.propTypes = {
  user: PropTypes.shape({}),
  openSignUpModal: PropTypes.func.isRequired,
  openQuizFinishedModal: PropTypes.func.isRequired,
  quiz: PropTypes.shape({
    category: PropTypes.string,
    step: PropTypes.number,
    color: PropTypes.string,
  }),
};

const mapStateToProps = (state) => ({
  user: userObjectSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  openSignUpModal: () => dispatch(modalsActions.openModalRequest({
    modal: MODALS.SIGN_UP_FOR_INNOVATION,
  })),
  openQuizFinishedModal: (color) => dispatch(modalsActions.openModalRequest({
    modal: MODALS.QUIZ_FINISHED,
    data: { color },
  })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Quiz);
